<template>
  <div class="livechat-container" id="livechat-container">
    <div class="livechat-button" id="livechat-button">
      <div class="icon notify-new-message hide-new-message" id="notification1"></div>
      <div class="icon icon24 off-livechat" v-on:click="hideButton"></div>
      <div draggable="true" class="icon icon-button-livechat" v-on:click="showChatButton"></div>
    </div>
  </div>
</template>

<script>
import {getCurrentInstance, nextTick, onMounted, ref} from 'vue';
export default {
  props: {},
  setup(props) {
    const {proxy} = getCurrentInstance();

    onMounted(async () => {
      initDragLiveChat();
    });

    // LiveChatWidget.call('maximize');

    function hideButton() {
      document.querySelector('.livechat-button').style.display = 'none';
      document.querySelector('.livechat-container').style.display = 'none'; //khi đóng icon đóng cả thẻ cha của nó đi để không bị ảnh hưởng tới click các màn hình có z-index nhỏ hơn nó-htthoa 29.5.2024
      document.querySelector('.live-chat-icon ').style.display = 'flex';
    }

    function showChat() {
      LiveChatWidget.call('maximize');
      document.querySelector('.live-chat-icon ').style.display = 'none';
      // document.querySelector(".livechat-button").style.display = "flex";
    }

    function showChatButton() {
      LiveChatWidget.call('maximize');
      document.querySelector('.livechat-button').style.display = 'none';
    }

    if (window._off_livechat == false) {
      LiveChatWidget.on('visibility_changed', function (data) {
        if (data.visibility === 'hidden') {
          document.querySelector('.livechat-button').style.display = 'flex';

          LiveChatWidget.on('new_event', function (event) {
            switch (event.type) {
              case 'message':
                document.getElementById('notification1')?.classList.remove('hide-new-message');
                document.getElementById('notification2')?.classList.remove('hide-new-message');
                break;

              case 'rich_message':
                // handle new rich_message event
                document.getElementById('notification1')?.classList.remove('hide-new-message');
                document.getElementById('notification2')?.classList.remove('hide-new-message');
                break;

              case 'file':
                // handle new file eventS
                document.getElementById('notification1')?.classList.remove('hide-new-message');
                document.getElementById('notification2')?.classList.remove('hide-new-message');
                break;

              default:
                break;
            }

            if (event.greeting) {
              // new event is a greeting
              // greeting properties are available
              var id = greeting.id;
              var uniqueId = greeting.uniqueId;
            }
          });
        }

        if (data.visibility === 'maximized') {
          document.querySelector('.livechat-button').style.display = 'none';
          document.getElementById('notification1')?.classList.add('hide-new-message');
          document.getElementById('notification2')?.classList.add('hide-new-message');
        }
      });
    }

    const initDragLiveChat = () => {
      dragElement(document.getElementById('livechat-container'));

      function dragElement(elmnt) {
        var pos1 = 0,
          pos2 = 0,
          pos3 = 0,
          pos4 = 0;
        if (elmnt) {
          if (document.getElementById(elmnt.id + '-button')) {
            /* if present, the header is where you move the DIV from:*/
            document.getElementById(elmnt.id + '-button').onmousedown = dragMouseDown;
          } else {
            /* otherwise, move the DIV from anywhere inside the DIV:*/
            elmnt.onmousedown = dragMouseDown;
          }

          function dragMouseDown(e) {
            e = e || window.event;
            e.preventDefault();
            // get the mouse cursor position at startup:
            pos3 = e.clientX;
            pos4 = e.clientY;
            document.onmouseup = closeDragElement;
            // call a function whenever the cursor moves:
            document.onmousemove = elementDrag;
          }

          function elementDrag(e) {
            e = e || window.event;
            e.preventDefault();
            // calculate the new cursor position:
            pos1 = pos3 - e.clientX;
            pos2 = pos4 - e.clientY;
            pos3 = e.clientX;
            pos4 = e.clientY;
            // set the element's new position:
            elmnt.style.top = elmnt.offsetTop - pos2 + 'px';
            elmnt.style.left = elmnt.offsetLeft - pos1 + 'px';
            document.getElementById('livechat-button').classList.add('dragging');
          }

          function closeDragElement() {
            /* stop moving when mouse button is released:*/

            //  Gắn vào 1 trong 2 bên mép trình duyệt
            if (document.body.offsetWidth / 2 > elmnt.offsetLeft) {
              // elmnt.style.left = elmnt.offsetLeft - pos1 + 'px';
              elmnt.style.left = 20 + 'px';
            } else {
              elmnt.style.left = document.body.offsetWidth - 70 + 'px';
            }

            document.onmouseup = null;
            document.onmousemove = null;
            document.getElementById('livechat-button').classList.remove('dragging');
          }

          //   document.getElementsByClassName('icon-button-livechat')[0].addEventListener('click', showChatButton);
        }
      }
    };

    return {
      hideButton,
      showChat,
      showChatButton,
    };
  },
};
</script>

<style lang="scss">
.livechat-container {
  position: fixed;
  height: 56px;
  width: 56px;
  right: 12px;
  bottom: 50px;
  display: block;
  z-index: 9999999;
  filter: drop-shadow(0 0 6px grey);
  cursor: pointer;

  .dragging {
    pointer-events: none;
  }
  .livechat {
    position: absolute;
  }

  .livechat-button {
    height: inherit;
    width: inherit;
    .icon-button-livechat {
      background-image: url('/src/assets/images/icons/ic-chat.svg');
      background-size: 22px;
      background-position: center;
      background-repeat: no-repeat;
      background-color: #2680eb !important;
      height: inherit;
      width: inherit;
      border-radius: 50%;
    }
    .off-livechat {
      position: absolute;
      top: -3px;
      right: -5px;
      background: #fff;
      height: 17px;
      width: 17px;
      border-radius: 50%;
      z-index: 20;
      box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    }
    .icon24.off-livechat::before {
      background-position: -243px -100px;
    }
  }
  .dragging {
    pointer-events: none;
  }
}
</style>
